import { BaseStore } from '../types';
import { StoreName } from './index';

export type Stores = {
  [key in StoreName]: BaseStore<unknown>;
};

export const stores: Stores = {};

// expose stores directly to window in dev build
if (process.env.NODE_ENV === 'development') {
  // @ts-expect-error for debug only
  window.stores = stores;
}
